import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'mandae-options-form',
  templateUrl: './options-form.component.html',
  styleUrls: ['./options-form.component.scss']
})
export class OptionsFormComponent implements OnInit {

  private _deliveryTypes = [];
  public get deliveryTypes() {
    return this._deliveryTypes;
  }
  @Input() public set deliveryTypes(value: any[]) {
    this._deliveryTypes = value.slice();
    this._deliveryTypes.sort((a, b) => b.indicadorPreco - a.indicadorPreco);
  }
  @Input() submitted = false;

  @Output() tipoEntrega = new EventEmitter<any>();
  @Output() valorDeclarado = new EventEmitter<any>();

  public valorDeclaradoInserido = 0;

  private insuranceValidationRules = [
    Validators.min(18),
    Validators.max(10000),
    Validators.required,
  ];

  public withInsurance = new FormControl(true);
  public declaredValue = new FormControl('', {
    validators: this.insuranceValidationRules,
  });
  public optionsForm = new FormGroup({
    withInsurance: this.withInsurance,
    declaredValue: this.declaredValue,
  });

  public selectedDeliveryType;

  constructor() { }

  ngOnInit() {
    this.withInsurance.valueChanges.subscribe((value: boolean) => {
      this.declaredValue.setValidators(value ? this.insuranceValidationRules : []);

      if (!value) {
        this.valorDeclarado.emit(null);
      }
    });

    this.declaredValue.valueChanges.subscribe((value: number) => {
      if (this.declaredValue.valid) {
        this.valorDeclarado.emit(value);
      }
      this.valorDeclaradoInserido = value;
    });
  }

  setDeliveryType(type: any) {
    this.selectedDeliveryType = type;
    this.tipoEntrega.emit(type);
  }

  getDeliveryTypeClass(type: any) {
    return {
      'active': this.selectedDeliveryType && this.selectedDeliveryType.tipo === type.tipo,
      'service-disable': !type.disponivel
    };
  }

  getDeliveryTypeIconClass(deliveryType: any) {
    return {
      'icon-checked': this.selectedDeliveryType && this.selectedDeliveryType.tipo === deliveryType.tipo && deliveryType.disponivel,
      'icon-unchecked': (!this.selectedDeliveryType || this.selectedDeliveryType.tipo !== deliveryType.tipo) && deliveryType.disponivel,
      'icon-disable': !deliveryType.disponivel,
    };
  }

  createDollars(price: number) {
    price = +price;

    if (price > 0) {
      return '<font color="#BBBBBB">' + '$'.repeat(price) + '</font>';
    }

    return '';
  }

}
